import { createSlice } from '@reduxjs/toolkit';
import { PURGE } from 'redux-persist';

const INITIAL_STATE = {
  userDetails: {
    name: '',
    lastName: '',
    email: '',
    dateLoggedIn: '',
    dateLoggedOut: '',
    Device: Date.now(),
  },
};

const userDetailsSlice = createSlice({
  name: 'userDetails',
  initialState: INITIAL_STATE,
  reducers: {
    updateUserDetailsOnIn: (state, action) => ({
      userDetails: {
        ...state.userDetails,
        name: action.payload,
        lastName: action.payload,
        email: action.payload,
        dateLoggedIn: '2022-10-10',
      },
    }),
    updateUserDetailsOnOut: (state, action) => ({
      userDetails: {
        ...state.userDetails,
        dateLoggedOut: '2022-10-45',
      },
    }),
    updateUserDetailsDevice: (state, action) => ({
      userDetails: {
        ...state.userDetails,
        Device: state.userDetails.Device + '1',
      },
    }),
    updateUserDetailsOnSignIn: (state, action) => ({
      userDetails: {
        ...state.userDetails,
        ...action.payload,
      },
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => INITIAL_STATE); // THIS LINE
  },
});

export const { updateUserDetailsOnIn, updateUserDetailsOnOut, updateUserDetailsDevice, updateUserDetailsOnSignIn } =
  userDetailsSlice.actions;

export default userDetailsSlice.reducer;
